import React, { FC } from 'react';

import { Box, BoxProps, Stack } from '@chakra-ui/react';

import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';

interface Props extends BoxProps {
  header: string;
}

export const MetadataBoxWithHeader: FC<Props> = props => {
  const { header, children, ...rest } = props;

  return (
    <BorderedBox p={4} minW={0} minH={0} {...rest}>
      <Stack w="full" h="full" minW={0} minH={0} overflow="hidden">
        <Box fontWeight={600}>{header}</Box>
        <Box flex={1} w="full" minW={0} minH={0} overflow="hidden">
          {children}
        </Box>
      </Stack>
    </BorderedBox>
  );
};
